import { Breadcrumbs, createStyles, Container, Skeleton } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  root: {
    color: "white",
    fontSize: "16px",
    lineHeight: "25px",
    textDecoration: "none",
  },
  separator: {
    color: "white",
    fontSize: "16px",
  },
}));

const CPageHeaderSkeleton = () => {
  const { classes, theme } = useStyles();

  const breadLinks = Array.from(Array(2)).map((item, index) => (
    <Skeleton key={index} height={20} width={100} />
  ));

  return (
    <section className="bg-gradient-to-r from-lightPrimary to-darkPrimary ">
      <Container className="relative min-h-[300px] flex flex-col items-center justify-center">
        <Skeleton height={48} width={218} />
        <Skeleton height={62} my={6} className="max-w-[600px]" />
        <Breadcrumbs
          className="my-3 mb-4 font-bold absolute top-5 left-3"
          classNames={{
            separator: classes.separator,
          }}
        >
          {breadLinks}
        </Breadcrumbs>
      </Container>
    </section>
  );
};
export default CPageHeaderSkeleton;
